import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DcrDerApprovalPage } from '@/features/billing/pages/DcrDerApprovalPage';
import { approvalSearchSchema } from '@/features/billing/types/billing.types';

export const Route = createFileRoute('/_auth/billing/approval')({
  validateSearch: approvalSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="DCR & DER Approval">
      <Suspense fallback={<PageLoader />}>
        <DcrDerApprovalPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
